import callNativeMethod from './callNativeMethod';
import checkIfInterfaceExist from './checkIfInterfaceExist';
import NATIVEFUNCTION_TYPE from './nativeFunctionType';
import myInterface from './myInterface';

/**
 * @param {*} hawkeyeEventJson
 * @return {*}
 */
const pushHawkeyeEvent = (hawkeyeEventJson) => {
  const methodBody = {
    functionName: NATIVEFUNCTION_TYPE.pushHawkeyeEvent,
    parameters: {
      argument1: hawkeyeEventJson,
    },
  };
  try {
    callNativeMethod(methodBody);
    return true;
  } catch (error) {
    if (checkIfInterfaceExist('pushHawkeyeEvent')) {
      console.log(hawkeyeEventJson);
      return myInterface.pushHawkeyeEvent(JSON.stringify(hawkeyeEventJson));
    }
  }
};

export default pushHawkeyeEvent;
